import axios from 'axios';
import { getHostname } from './server/server' 

const hostname = getHostname();
const slackPath = '/v2/slack';

const formatMessageForSlack = (heading, text, data) => {

    let formattedText = `\t${text}`;

    // format json data for slack message if provided
    if (data) {
        formattedText += `\n\`\`\`${JSON.stringify(data, null, 2)}\`\`\``;
    }

    return {
        type: 'mrkdwn',
        text: `*${heading}*`,
        attachments: [
            {
                text: `\t${formattedText}`,
                color: '#353A44',
            },
        ],
    };
}

const sendSlackMessage = async (heading, text, data = false, channel=false) => {
    const message = formatMessageForSlack(heading, text, data);

    const body = {message} 
    if (channel) body.channel = channel;

    const res = await axios.post(`${hostname}${slackPath}`, body);
    return res.data;
}

export { sendSlackMessage };